<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.459"
    height="14.329"
    viewBox="0 0 23.459 14.329"
  >
    <g transform="translate(-408.352 -539.36)">
      <g>
        <path
          d="M430.99,553.689a.5.5,0,0,1-.159-.026l-11.423-3.849h-7.455a.5.5,0,0,1-.5-.5v-8.47a.5.5,0,0,1,.932-.251,9.419,9.419,0,0,0,1.835,2.262c1.207,1.263,2.7,1.233,5.034-.065a.688.688,0,0,0,.417-.525c.091-.7-.8-1.736-1.122-2.046a.5.5,0,0,1,.619-.78c.384.246,9.419,6.057,11.365,8.073,2.114,2.192.98,5.688.932,5.835A.5.5,0,0,1,430.99,553.689Zm-18.537-4.875h7.037a.514.514,0,0,1,.16.026l10.991,3.7c.2-.935.454-3.006-.827-4.336-1.33-1.377-6.395-4.784-9.231-6.652a2.078,2.078,0,0,1,.08.84,1.683,1.683,0,0,1-.922,1.268c-1.718.958-4.229,1.988-6.218-.091a9.9,9.9,0,0,1-1.069-1.127Z"
          fill="#777"
        />
      </g>
      <path
        d="M431.19,551.3l-12.061-4.271h-7.215v-1l7.468.028,12.142,4.3Z"
        fill="#777"
      />
      <rect
        width="1"
        height="5"
        transform="translate(408.353 544.131)"
        fill="#777"
      />
      <rect
        width="2"
        height="1"
        transform="translate(408.353 544.131)"
        fill="#777"
      />
      <rect
        width="2"
        height="1"
        transform="translate(408.353 548.131)"
        fill="#777"
      />
    </g>
  </svg>
</template>
